<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Salesman {{ (salesman.first_name) ? (" - " + salesman.first_name) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Salesman - {{salesman.first_name}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Salesman - {{salesman.first_name}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode != 2">
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="salesman.code" input-classes="form-control" />
                        <base-input alternative="" label="First Name" placeholder="" v-model="salesman.first_name" input-classes="form-control" required />
                        <base-input alternative="" label="Last Name" placeholder="" v-model="salesman.last_name" input-classes="form-control" required />
                        <base-input alternative="" label="Address" placeholder="" v-model="salesman.address" input-classes="form-control" />
                        <base-input alternative="" label="Phone" placeholder="" v-model="salesman.telephone" input-classes="form-control" />
                        <base-input alternative="" label="Fax" placeholder="" v-model="salesman.fax" input-classes="form-control" />
                        <base-input alternative="" label="TIN" placeholder="" v-model="salesman.tin" input-classes="form-control" />
                        <base-input alternative="" label="Position" placeholder="" v-model="salesman.position" input-classes="form-control" />
                        <base-input alternative="" label="Email" placeholder="" v-model="salesman.email" input-classes="form-control" />
                        <base-input alternative="" label="Commission" placeholder="" v-model="salesman.commission_rate" input-classes="form-control" />
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="salesman.remark" />
                        </base-input>
                        <br><br>
                    </a-tab-pane>

                    <a-tab-pane tab="Valid Sites" key="2" forceRender>
                        <a-select mode="multiple" style="width: 100%" placeholder="Please select" v-model="salesman.valid_sites" optionFilterProp="children" :disabled="this.$attrs.viewMode">
                            <a-select-option v-for="site in siteOptions" :key="site.name" :value="site.id">{{site.name}}</a-select-option>
                        </a-select>
                    </a-tab-pane>

                    <a-tab-pane v-if="customFormMode == 3" tab="Custom Fields" key="3" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="salesman" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>

            <div v-if="customFormMode == 2">
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="salesman" @valueUpdated="updateSettings" :key="dynamicFormKey" />
            </div>

            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>

            <!-- <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
            </div> -->
        </form>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    import DynamicForm from '../DynamicForm.vue'

    var component_x;
    export default {
        components:{
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {
            // Meta-data Call
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Salesman?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
                if(accSystemModule != null){
                    if(accSystemModule.form_mode != undefined){
                        this.customFormMode = accSystemModule.form_mode
                    }
                    if(accSystemModule.customized_forms != undefined){
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }

            component_x = this
            
            var site_data = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites', null)
            component_x.siteOptions = site_data
            component_x.inputValidSites = []

            if (component_x.profileId > 0) {
                var salesman_data = await HTTPRequest.getRequest(component_x.endPoint + 'salesmen/' + component_x.profileId, null)
                if (salesman_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (salesman_data["error"] == undefined) {
                        component_x.salesman = salesman_data
                    } else {
                        this.errors = salesman_data["error"].split(",");
                    }
                }
            }

            this.dynamicFormKey++;
        },
        data: function () {
            return {
                siteOptions: '',
                errors: [],

                // FOR META-DATA
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                salesman: {
                    first_name: '',
                    last_name: '',
                    code: '',
                    valid_sites: []
                },
                formErrors: []
            }
        },
        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.salesman
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors

                if(this.customFormMode == 3) {
                    this.errors = errors
                }

                this.salesman = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },

            validateForm(){
                this.errors = [];
                if(this.customFormMode != 2){
                    // this.errors.push(ValidateField.required('Code', this.salesman.code));
                    // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.salesman.code));
                    this.errors.push(ValidateField.charMinAndMax('Code', this.salesman.code, 0, 30));
                    this.errors.push(ValidateField.required('First Name', this.salesman.first_name));
                    this.errors.push(ValidateField.alphanumericWithSpace('First Name', this.salesman.first_name));
                    this.errors.push(ValidateField.charMinAndMax('First Name', this.salesman.first_name, 0, 50));
                    this.errors.push(ValidateField.required('Last Name', this.salesman.last_name));
                    this.errors.push(ValidateField.alphanumericWithSpace('Last Name', this.salesman.last_name));
                    this.errors.push(ValidateField.charMinAndMax('Last Name', this.salesman.last_name, 0, 50));
                    this.errors.push(ValidateField.charMinAndMax('Address', this.salesman.address, 0, 30));
                    this.errors.push(ValidateField.phoneNumberFormat('Phone', this.salesman.telephone));
                    this.errors.push(ValidateField.charMinAndMax('Phone', this.salesman.telephone, 0, 30));
                    this.errors.push(ValidateField.phoneNumberFormat('Fax', this.salesman.fax));
                    this.errors.push(ValidateField.charMinAndMax('Fax', this.salesman.fax, 0, 20));
                    this.errors.push(ValidateField.alphanumeric('Tin', this.salesman.tin));
                    this.errors.push(ValidateField.charMinAndMax('Tin', this.salesman.tin, 0, 50));
                    this.errors.push(ValidateField.alphanumericWithSpecialChars('Position', this.salesman.position));
                    this.errors.push(ValidateField.charMinAndMax('Position', this.salesman.position, 0, 50));
                    if(this.salesman.email != null && this.salesman.email != ""){
                        this.errors.push(ValidateField.emailFormat('Email', this.salesman.email));
                        // this.errors.push(ValidateField.emailFormat('Email', this.inputEmail));
                    }
                    this.errors.push(ValidateField.charMinAndMax('Email', this.salesman.email, 0, 30));
                    this.errors.push(ValidateField.decimalFormat('Commission', this.salesman.commission_rate));
                    this.errors.push(ValidateField.requiredOne('Valid Sites', this.salesman.valid_sites));
                    this.errors = this._.compact(this.errors);
                }
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
                
            },
            create: async function () {
                if(!this.validateForm()) {
                    // var salesmanPayload = {
                    //     salesman: {
                    //         code: this.inputCode,
                    //         first_name: this.inputFirstName.trim(),
                    //         last_name: this.inputLastName.trim(),
                    //         address: this.inputAddress,
                    //         telephone: this.inputTelephone,
                    //         fax: this.inputFax,
                    //         tin: this.inputTin,
                    //         position: this.inputPosition,
                    //         email: this.inputEmail,
                    //         commission_rate: this.inputCommission,
                    //         remark: this.inputRemark,
                    //         valid_sites: this.inputValidSites,
                    //         status: 'A'
                    //     }
                    // }
                    this.salesman.first_name = this.salesman.first_name.trim()
                    this.salesman.last_name = this.salesman.last_name.trim()
                    this.salesman.code = this.salesman.code.trim()
                    this.salesman.status = 'A'
                    var salesmanPayload = { salesman: this.salesman }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'salesmen', null, salesmanPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    // var salesmanPayload = {
                    //     salesman: {
                    //         code: this.inputCode,
                    //         first_name: this.inputFirstName.trim(),
                    //         last_name: this.inputLastName.trim(),
                    //         address: this.inputAddress,
                    //         telephone: this.inputTelephone,
                    //         fax: this.inputFax,
                    //         tin: this.inputTin,
                    //         position: this.inputPosition,
                    //         email: this.inputEmail,
                    //         commission_rate: this.inputCommission,
                    //         remark: this.inputRemark,
                    //         valid_sites: this.inputValidSites,
                    //         status: 'A'
                    //     }
                    // }
                    this.salesman.first_name = this.salesman.first_name.trim()
                    this.salesman.last_name = this.salesman.last_name.trim()
                    this.salesman.code = this.salesman.code.trim()
                    let status = (this.salesman.status == null) ?  "A" : this.salesman.status
                    this.salesman.status = status
                    var salesmanPayload = { salesman: this.salesman }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'salesmen/' + this.profileId, null, salesmanPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>